// extracted by mini-css-extract-plugin
export var resizer = "_e9-0";